/**
 * Độ rộng 1 item của combobox theo thiết lập hiển thị
 * NVTUAN1 20.11.2023
 */
export default {
  HeightSmall: 22 + 2, //Nhỏ 1 item 22px + 2x border
  HeightBig: 26 + 2, //Lớn 1 item 26px + 2x border
};